import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';

import { SendoutStatuses } from '@app/constants/sendoutStatuses';

const { Text } = Typography;

export const getStatusText = (Status?: string, ErrorMessage?: string) => {
  switch (Status) {
    case SendoutStatuses.CREATED:
      return <Text>Черновик</Text>;
    case SendoutStatuses.RUNNING:
      return <Text style={{ color: 'rgb(2, 117, 216)' }}>Запущена</Text>;
    case SendoutStatuses.COMPLETED:
      return <Text style={{ color: 'rgb(45, 165, 64)' }}>Завершена</Text>;
    case SendoutStatuses.STOPPED:
      return <Text style={{ color: 'rgb(225, 79, 79)' }}>Остановлена</Text>;
    case SendoutStatuses.PAUSED:
      return <Text style={{ color: 'rgb(33 58 255)' }}>На паузе</Text>;
    case SendoutStatuses.ERROR:
      return (
        <Tooltip title={ErrorMessage}>
          <Text style={{ color: 'rgb(225, 79, 79)' }}>
            Проблема <InfoCircleOutlined />
          </Text>
        </Tooltip>
      );
    default:
      return <Text>{Status}</Text>;
  }
};
